import LineController from "./line_controller"

export default class extends LineController {
    static targets = ['code', 'name', 'price', 'cost', 'unit', 'number', 'quantity', 'amount', 'taxType', 'addLine', 'destroy']

}
